import axios from 'axios';

export default {

  getUsers() {
    return axios.get('api/users')
  },

  getCurrentUser() {
    return axios.get('/users/current')
  },

}